module.exports = __webpack_public_path__ + "static/media/tourism.4ae7e49f.svg";